<template>
<div class="actions-container position-sticky" id="batchManagementHeader">
  <div class="container" id="batchManagementHeader-container">
    <div class="row" id="batchManagementHeader-row">
      <div class="col-lg-5 order-lg-2" id="batchManagementHeader-rightCol">
        <form class="row mb-3 mb-lg-0"  id="batchManagementHeader-formDiv">
          <div class="col-7"  id="batchManagementHeader-actionsDropdown">

            <!-- ACTIONS DROPDOWN -->
            <select v-model="selectedAction" class="form-control"  id="batchManagementHeader-selectAction">
              <template v-for="(roles, action) in actions">
                <option v-if="isRoleBasedAccessAllowed(roles)" :value="action" :id="'batchManagementHeader-select-option-'+action">
                  {{ action.toUpperCase() | translate('action') }}
                </option>
              </template>
            </select>

          </div>
          <div class="col-5"  id="batchManagementHeader-buttonDiv">

            <!-- EXECUTE BUTTON -->
            <button type="button" class="btn btn-block btn-success"
                    :disabled="batchSelectionEmpty && !file"
                    @click="execute"
                    id="batchManagementHeader-executeButton">
              {{ 'EXECUTE' | translate }}
            </button>

          </div>
        </form>
      </div>
      <div class="col-lg-7 order-lg-1" id="batchManagementHeader-leftCol">

        <!-- CHECKBOX FOR SELECTING ALL -->
        <div class="custom-control alternative custom-checkbox mt-2 mr-3 pull-left" style="margin-left: 0.75rem;"  id="batchManagementHeader-checkbox">
          <input type="checkbox" class="custom-control-input" id="checkbox_ALL"
                  :indeterminate.prop="indeterminate" v-model="allSelected" @change="toggleSelectAll($event)">
          <label class="custom-control-label" for="checkbox_ALL" id="batchManagementHeader-checkbox-label">Select All</label>
        </div>

        <!-- UPLOAD A LIST OF CASE IDS UPLOAD -->
        <form v-on:submit.prevent="" id="batchManagementHeader-uploadFormDiv">
          <div class="form-group mb-0" id="batchManagementHeader-uploadFormGroup">
            <div class="form-row" id="batchManagementHeader-uploadFormRow">
              <div class="col-lg-8" id="batchManagementHeader-uploadFormCol">
                <div class="custom-file" id="batchManagementHeader-uploadForm-customFile">
                  <input type="file" class="custom-file-input" id="close_file" name="close_file"
                        ref="fileInput" v-on:change="selectFile" required>
                  <span v-if="file" class="deselect-file text-warning" @click="deselectFile">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </span>
                  <label class="custom-file-label text-truncate" for="close_file" id="batchManagementHeader-uploadForm-customFile-label">
                    {{ (file && file.name) ? file.name : 'UPLOAD_CASE_IDS_LIST' | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>
</template>

<script>
import KeycloakService from '../../service/keycloak/KeycloakService';
import RestService from '../../service/RestService.js';

export default {
  props: [ 'actions', 'batchSelectionEmpty' ],
  data() {
    return {
      rest: this.initRestService(),
      allSelected: false,
      indeterminate: false,
      selectedAction: null,
      file: null
    }
  },
  computed: {
    availableActions() {
      return Object.keys(this.actions).filter(actionType => this.isRoleBasedAccessAllowed(this.actions[actionType]));
    }
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    isRoleBasedAccessAllowed(roles) {
      return KeycloakService.isRoleBasedAccessAllowed(roles);
    },
    updateCheckbox(allSelected, indeterminate) {
      this.allSelected = allSelected;
      this.indeterminate = indeterminate;
    },
    toggleSelectAll(e) {
      this.$emit('toggle-select-all', e.target.checked);
    },
    selectFile(e) {
      const files = e.target.files || e.dataTransfer.files;
      this.file = files[0];
      this.$emit('toggle-file-selected', !!this.file);
    },
    deselectFile() {
      this.$refs['fileInput'].value = '';
      this.file = null;
      this.$emit('toggle-file-selected', false);
    },
    execute() {
      if (this.file) {
        this.sendAction();
      } else {
        this.$emit('execute-action', this.selectedAction);
      }
    },
    sendAction() {
      const selectedActionUppercase = this.selectedAction.toUpperCase();
      this.rest.sendCaseListAction(this.selectedAction, this.file).then(() => {
        this.$notify({
          type: 'alert-success',
          text: this.$options.filters.translate(selectedActionUppercase + '_ACTION_ADDED_QUEUE', 'msg')
        });
      }).catch((err) => {
        this.$notify({
          type: 'alert-danger',
          duration: -1,
          text: this.$options.filters.translate(selectedActionUppercase + '_ACTION_NOT_ADDED_QUEUE', 'msg') + '\n' +
            this.$options.filters.translateApiMessage(err.response.data)
        });
        if (typeof err.response !== 'undefined') {
          this.$log.error(err.response.data);
        } else {
          this.$log.error(err);
        }
      });
    }
  },
  watch: {
    availableActions: {
      immediate: true,
      handler(newVal) {
        this.selectedAction = newVal[0];
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .actions-container {
    top: 56px;
    padding-top: 11px;
    padding-bottom: 11px;
    box-shadow: 0 3px 3px rgba(0, 0, 0, .05);
    background-color: #fff;
    z-index: 10;
  }

  .custom-file {
    .custom-file-label {
      padding-right: 80px;
    }

    .deselect-file {
      position: absolute;
      z-index: 2;
      top: 0px;
      right: 68px;
      width: 30px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/batch/BatchManagementHeader.vue